import { render, staticRenderFns } from "./question_icon.vue?vue&type=template&id=33d44afa&scoped=true&"
import script from "./question_icon.vue?vue&type=script&lang=js&"
export * from "./question_icon.vue?vue&type=script&lang=js&"
import style0 from "./question_icon.vue?vue&type=style&index=0&id=33d44afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d44afa",
  null
  
)

export default component.exports